module.exports.eightyeight = [
  {
    "cities": "Amsterdam",
    "gdp": 1479,
    "automobile_mechanic": 1608,
    "cook": 1950,
    "department_manager": 3667,
    "primary_school_teacher": 2142,
    "sales_assistant": 1408
  },
  {
    "cities": "Bangkok",
    "gdp": 94,
    "automobile_mechanic": 175,
    "cook": 1000,
    "department_manager": 992,
    "primary_school_teacher": 217,
    "sales_assistant": 175
  },
  {
    "cities": "Bogotá",
    "gdp": 103,
    "automobile_mechanic": 308,
    "cook": 900,
    "department_manager": 1125,
    "primary_school_teacher": 225,
    "sales_assistant": 117
  },
  {
    "cities": "Brussels",
    "gdp": 1366,
    "automobile_mechanic": 1292,
    "cook": 2825,
    "department_manager": 5383,
    "primary_school_teacher": 1775,
    "sales_assistant": 1350
  },
  {
    "cities": "Buenos Aires",
    "gdp": 332,
    "automobile_mechanic": 258,
    "cook": 908,
    "department_manager": 508,
    "primary_school_teacher": 167,
    "sales_assistant": 208
  },
  {
    "cities": "Cairo",
    "gdp": 55,
    "automobile_mechanic": 67,
    "cook": 133,
    "department_manager": 358,
    "primary_school_teacher": 92,
    "sales_assistant": 50
  },
  {
    "cities": "Chicago",
    "gdp": 1785,
    "automobile_mechanic": 2450,
    "cook": 2575,
    "department_manager": 3500,
    "primary_school_teacher": 2708,
    "sales_assistant": 858
  },
  {
    "cities": "Copenhagen",
    "gdp": 1877,
    "automobile_mechanic": 2608,
    "cook": 3617,
    "department_manager": 6425,
    "primary_school_teacher": 2358,
    "sales_assistant": 1675
  },
  {
    "cities": "Dublin",
    "gdp": 894,
    "automobile_mechanic": 1108,
    "cook": 1008,
    "department_manager": 3700,
    "primary_school_teacher": 1908,
    "sales_assistant": 1133
  },
  {
    "cities": "Frankfurt",
    "gdp": 1494,
    "automobile_mechanic": 1883,
    "cook": 2333,
    "department_manager": 6950,
    "primary_school_teacher": 2833,
    "sales_assistant": 1242
  },
  {
    "cities": "Geneva",
    "gdp": 2645,
    "automobile_mechanic": 2792,
    "cook": 3458,
    "department_manager": 5600,
    "primary_school_teacher": 4775,
    "sales_assistant": 2267
  },
  {
    "cities": "Helsinki",
    "gdp": 1837,
    "automobile_mechanic": 1508,
    "cook": 1767,
    "department_manager": 3933,
    "primary_school_teacher": 2167,
    "sales_assistant": 1350
  },
  {
    "cities": "Hong Kong",
    "gdp": 884,
    "automobile_mechanic": 900,
    "cook": 1133,
    "department_manager": 2783,
    "primary_school_teacher": 1158,
    "sales_assistant": 517
  },
  {
    "cities": "Istanbul",
    "gdp": 145,
    "automobile_mechanic": 675,
    "cook": 1800,
    "department_manager": 2700,
    "primary_school_teacher": 225,
    "sales_assistant": 358
  },
  {
    "cities": "Jakarta",
    "gdp": 40,
    "automobile_mechanic": 58,
    "cook": 350,
    "department_manager": 575,
    "primary_school_teacher": 50,
    "sales_assistant": 42
  },
  {
    "cities": "Johannesburg",
    "gdp": 226,
    "automobile_mechanic": 825,
    "cook": 1775,
    "department_manager": 1550,
    "primary_school_teacher": 983,
    "sales_assistant": 350
  },
  {
    "cities": "Kuala Lumpur",
    "gdp": 173,
    "automobile_mechanic": 233,
    "cook": 675,
    "department_manager": 1025,
    "primary_school_teacher": 425,
    "sales_assistant": 225
  },
  {
    "cities": "Lagos",
    "gdp": 46,
    "automobile_mechanic": 67,
    "cook": 100,
    "department_manager": 367,
    "primary_school_teacher": 58,
    "sales_assistant": 92
  },
  {
    "cities": "Lisbon",
    "gdp": 469,
    "automobile_mechanic": 375,
    "cook": 533,
    "department_manager": 633,
    "primary_school_teacher": 658,
    "sales_assistant": 233
  },
  {
    "cities": "London",
    "gdp": 1332,
    "automobile_mechanic": 1458,
    "cook": 1642,
    "department_manager": 3133,
    "primary_school_teacher": 1742,
    "sales_assistant": 1767
  },
  {
    "cities": "Los Angeles",
    "gdp": 1785,
    "automobile_mechanic": 3083,
    "cook": 2525,
    "department_manager": 4833,
    "primary_school_teacher": 3083,
    "sales_assistant": 1383
  },
  {
    "cities": "Luxembourg",
    "gdp": 2176,
    "automobile_mechanic": 1458,
    "cook": 1783,
    "department_manager": 4600,
    "primary_school_teacher": 2992,
    "sales_assistant": 1242
  },
  {
    "cities": "Madrid",
    "gdp": 809,
    "automobile_mechanic": 633,
    "cook": 1567,
    "department_manager": 983,
    "primary_school_teacher": 1417,
    "sales_assistant": 683
  },
  {
    "cities": "Manila",
    "gdp": 54,
    "automobile_mechanic": 92,
    "cook": 275,
    "department_manager": 433,
    "primary_school_teacher": 167,
    "sales_assistant": 100
  },
  {
    "cities": "Mexico City",
    "gdp": 187,
    "automobile_mechanic": 158,
    "cook": 150,
    "department_manager": 133,
    "primary_school_teacher": 158,
    "sales_assistant": 108
  },
  {
    "cities": "Milan",
    "gdp": 1312,
    "automobile_mechanic": 1475,
    "cook": 2150,
    "department_manager": 2350,
    "primary_school_teacher": 1442,
    "sales_assistant": 1342
  },
  {
    "cities": "Montreal",
    "gdp": 1578,
    "automobile_mechanic": 1950,
    "cook": 2358,
    "department_manager": 4442,
    "primary_school_teacher": 2492,
    "sales_assistant": 1308
  },
  {
    "cities": "Mumbai",
    "gdp": 30,
    "automobile_mechanic": 117,
    "cook": 158,
    "department_manager": 300,
    "primary_school_teacher": 133,
    "sales_assistant": 100
  },
  {
    "cities": "Nairobi",
    "gdp": 31,
    "automobile_mechanic": 192,
    "cook": 233,
    "department_manager": 875,
    "primary_school_teacher": 158,
    "sales_assistant": 208
  },
  {
    "cities": "New York",
    "gdp": 1785,
    "automobile_mechanic": 2650,
    "cook": 3333,
    "department_manager": 4850,
    "primary_school_teacher": 2167,
    "sales_assistant": 1192
  },
  {
    "cities": "Nikosia",
    "gdp": 637,
    "automobile_mechanic": 717,
    "cook": 975,
    "department_manager": 1558,
    "primary_school_teacher": 1308,
    "sales_assistant": 383
  },
  {
    "cities": "Oslo",
    "gdp": 2017,
    "automobile_mechanic": 2000,
    "cook": 2217,
    "department_manager": 3275,
    "primary_school_teacher": 1875,
    "sales_assistant": 2067
  },
  // {
  //   "cities": "Panama",
  //   "gdp": 208,
  //   "automobile_mechanic": 442,
  //   "cook": 1192,
  //   "department_manager": 1767,
  //   "primary_school_teacher": 458,
  //   "sales_assistant": 408
  // },
  {
    "cities": "Paris",
    "gdp": 1473,
    "automobile_mechanic": 958,
    "cook": 2067,
    "department_manager": 2425,
    "primary_school_teacher": 1442,
    "sales_assistant": 825
  },
  {
    "cities": "Rio de Janeiro",
    "gdp": 192,
    "automobile_mechanic": 250,
    "cook": 492,
    "department_manager": 1042,
    "primary_school_teacher": 133,
    "sales_assistant": 175
  },
  {
    "cities": "São Paulo",
    "gdp": 192,
    "automobile_mechanic": 250,
    "cook": 267,
    "department_manager": 458,
    "primary_school_teacher": 233,
    "sales_assistant": 183
  },
  {
    "cities": "Seoul",
    "gdp": 391,
    "automobile_mechanic": 600,
    "cook": 1050,
    "department_manager": 1700,
    "primary_school_teacher": 908,
    "sales_assistant": 467
  },
  {
    "cities": "Stockholm",
    "gdp": 2028,
    "automobile_mechanic": 1483,
    "cook": 1400,
    "department_manager": 4050,
    "primary_school_teacher": 1900,
    "sales_assistant": 1600
  },
  {
    "cities": "Sydney",
    "gdp": 1188,
    "automobile_mechanic": 1192,
    "cook": 1500,
    "department_manager": 3250,
    "primary_school_teacher": 1892,
    "sales_assistant": 1108
  },
  {
    "cities": "Tel Aviv",
    "gdp": 940,
    "automobile_mechanic": 992,
    "cook": 1600,
    "department_manager": 1658,
    "primary_school_teacher": 642,
    "sales_assistant": 617
  },
  {
    "cities": "Tokyo",
    "gdp": 2088,
    "automobile_mechanic": 1758,
    "cook": 2492,
    "department_manager": 6083,
    "primary_school_teacher": 3683,
    "sales_assistant": 1675
  },
  {
    "cities": "Toronto",
    "gdp": 1578,
    "automobile_mechanic": 1933,
    "cook": 2525,
    "department_manager": 2908,
    "primary_school_teacher": 2808,
    "sales_assistant": 1067
  },
  {
    "cities": "Vienna",
    "gdp": 1465,
    "automobile_mechanic": 1592,
    "cook": 2108,
    "department_manager": 3892,
    "primary_school_teacher": 1567,
    "sales_assistant": 992
  },
  {
    "cities": "Zurich",
    "gdp": 2645,
    "automobile_mechanic": 3042,
    "cook": 3358,
    "department_manager": 6758,
    "primary_school_teacher": 4492,
    "sales_assistant": 2033
  }
]
